import api from '@/utils/api';

/**
 * Get all the prices for a specific company
 * @param {string} id - The company ID
 * @returns {Promise}
 */
export const getCompanyPriceListSelect = (id) =>
  api.get(`conf/${id}/price-select`);

export default getCompanyPriceListSelect;
